import MessengerAdCRUDActions from '../actions/MessengerAdCRUDActions';
import Actions from '../actions/actions';
import {
  retrieved,
  retrievedAll,
  update,
  deleteLocalFirst,
  setBusy,
  setUnBusy,
} from './common/commonReducers';
import { MessengerAds } from '../interfaces/messenger-ads';

const initialState: MessengerAds = {
  busy: false,
  entities: [],
};

export default function messengerAds(state = initialState, action: any) {
  switch (action.type) {
    case MessengerAdCRUDActions.busyAction:
      return setBusy(state);
    case MessengerAdCRUDActions.unbusyAction:
      return setUnBusy(state);
    case MessengerAdCRUDActions.retrievedAction:
      return retrieved(state, action);
    case MessengerAdCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case MessengerAdCRUDActions.updateAction:
      return update(state, action);
    case MessengerAdCRUDActions.deleteLocalAction:
      return deleteLocalFirst(state, action);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
